import styled from 'styled-components'
import { Popover } from 'is24-corecss'

type PopOverProps = {
  visible?: boolean
  color?: string
  className?: string
  dataTesting?: string
  borderColor?: string
  bodyPosition?: string
  arrowPosition?: string
  secondaryLight?: string
}

const styledPopOver = styled(Popover)`
  #rle-wizard & {
    ${(props: PopOverProps) =>
      props.borderColor &&
      `
    border-color: ${props.borderColor} !important;
    `}
    ${(props: PopOverProps) =>
      props.color &&
      `
    color: ${props.color};
  `}
  }
`

export default styledPopOver
